import instance from './axiosInstance';
import type { ssdData, UpdateSsdPayload } from 'pages/ssd/type';

export const getSsd = async <T = ssdData>(ssdType: string): Promise<T> => {
  const res = await instance.get<T>('/ssd?ssd_type=' + ssdType);
  return res.data;
};

export const updateSsd = async (ssdData: UpdateSsdPayload) => {
  const res = await instance.post('/ssd', ssdData);
  return res.data;
};
